import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { AUTH_TOKEN } from '@/helpers/constants/app';
import ActionButton from '@/components/action_button/Index.vue';
import mutation from '@/plugins/graphql/mutations/v2/user-settings-reset-token.gql';
import query from '@/plugins/graphql/queries/me.gql';
import ButtonLoaderMixin from '../../helpers/vue_mixins/ButtonLoaderMixin';
import LogoutMixin from '../../helpers/mixins/LogoutMixin';
import AlertMixin from '../../helpers/vue_mixins/AlertMixin';
let UserSettingResetPasswordConfirm = class UserSettingResetPasswordConfirm extends Mixins(ButtonLoaderMixin, AlertMixin, LogoutMixin) {
    constructor() {
        super(...arguments);
        this.me = null;
    }
    onResetToken() {
        this.requestOnFlight();
        this.$apollo
            .mutate({
            mutation,
            variables: {
                input: { userUuid: this.value },
            },
            update: async (store, { data }) => {
                const { userSettingResetToken: { resetPasswordToken }, } = data;
                this.requestDone();
                this.$emit('input', null);
                const token = sessionStorage.getItem(AUTH_TOKEN);
                // Temporary fix for login issue
                // this.destroyToken(token);
                this.logout(`/reset-password/${resetPasswordToken}`);
            },
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.requestDone();
            this.$emit('input', null);
        });
    }
};
__decorate([
    Prop({ type: String, default: null })
], UserSettingResetPasswordConfirm.prototype, "value", void 0);
UserSettingResetPasswordConfirm = __decorate([
    Component({
        components: { ActionButton },
        apollo: {
            me: {
                query,
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
    })
], UserSettingResetPasswordConfirm);
export default UserSettingResetPasswordConfirm;
